// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';  // Import the auth context
import LoginPage from './Login';
import Dashboard from './Dashboard';

const ProtectedRoute = ({ element }) => {
  const { isAuthenticated } = useAuth();  // Make sure useAuth is imported
  return isAuthenticated ? element : <LoginPage />;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={<ProtectedRoute element={<Dashboard />} />}
          />
          {/* Add more routes as needed */}
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
